export default __webpack_public_path__ + "static/media/worship-favicon.6d542a7f.png";